// @ts-check

import { nextArrow, prevArrow, slickDefaults } from "../parts/slick-defaults";
import { debounce } from "../utilites/debounce";

const sections = document.querySelectorAll( '.features' );

const mediaQuery = window.matchMedia( '(min-width: 768px)' );


/**
 * @return void
 */
const setUpDesktopFeatures = debounce( assignLastRowItems, 400 );


setFeaturesLayout();
mediaQuery.addEventListener( 'change', setFeaturesLayout );


/**
 * @param {MediaQueryListEvent=} e
 *
 * @return void
 */
function setFeaturesLayout( e ) {
    if ( mediaQuery.matches ) {
        deSlickFeatures();
        setUpDesktopFeatures();
        window.addEventListener( 'resize', setUpDesktopFeatures );
    } else {
        slickFeatures();
        window.removeEventListener( 'resize', setUpDesktopFeatures );
    }
}

function slickFeatures() {
    sections.forEach( section => {
        const slider = section.querySelector( '.features__items' );
        if ( slider?.classList.contains( 'slick-initialized' ) ) return;
        jQuery( slider ).slick( {
            prevArrow,
            nextArrow,
            ...slickDefaults
        } );
    } );
}

function deSlickFeatures() {
    sections.forEach( section => {
        const slider = section.querySelector( '.features__items' );
        if ( !slider?.classList.contains( 'slick-initialized' ) ) return;
        jQuery( slider ).slick( 'unslick' );
    } );
}

/**
 *
 * @return void
 */
function assignLastRowItems() {
    sections.forEach( section => {
        const features = section.querySelectorAll( '.features__item' );

        let row = 1;
        let previousVal = features[0].offsetTop;
        features.forEach( ( item, i ) => {
            item.classList.add( 'end-of-row' );

            const is_same_row = ( item.offsetTop < previousVal + 10 ) && ( item.offsetTop > previousVal - 10 );

            if ( is_same_row ) {
                features.item( i - 1 )?.classList?.remove( 'end-of-row' );
            } else {
                row++;
            }

            previousVal = item.offsetTop;
        } );
    } );
}
